<app-create-operation [operation]="operation" [submissionMode$]="opModificationType" [draftId]="draftId"
                      #createOperationComponent></app-create-operation>
